<template>

  <div class="panel panel-default">

    <div class="panel-heading">

      <h2 v-if="!isNewUser">Edit User</h2>
      <h2 v-if="isNewUser">New User</h2>

      <router-link class="btn btn-default pull-right" to="/vue/manage/users" title="Create a new user">
        <span class="glyphicon glyphicon-arrow-left" aria-hidden="true"></span> Back
      </router-link>

    </div>
   
    <form name="formManagedUser" @submit.prevent="updateUser">
      <div class="panel-body">

        <div class="container" style="width: inherit; max-width: 700px;">
          
          <div v-if="!isNewUser">
            <h3 >User: {{selectedUser.username}}</h3>
            <hr />  
          </div>
          
          <div class="form-group" v-if="isNewUser">
            <div class="">
              <label for="inputUsername" class="required">Username</label>
              <input type="text" class="form-control" id="inputUsername" placeholder="Username" 
                     v-model="selectedUser.username" required >
            </div>
          </div>

          <div class="form-group">
            <div class="">
              <label for="inputFullName" class="required">Full Name</label>
              <input type="text" class="form-control" id="inputFullName" placeholder="Full Name"
                     v-model="selectedUser.name" required>
            </div>
          </div>

          <div class="form-group">
            <div class="">
              <label for="inputEmail" class="required">Email</label>
              <input type="text" class="form-control" id="inputEmail" placeholder="Email" v-model="selectedUser.email" required>
            </div>
          </div>

          <div class="form-group">
            <div class="">
              <label for="inputBarNumber">Bar Number</label>
              <input type="text" class="form-control" id="inputBarNumber" placeholder="Bar Number"
                     v-model="selectedUser.barNumber">
            </div>
          </div>

          <div class="form-group">
            <div class="">
              <input type="checkbox" id="inputDisabled" name="inputChangePassword" v-model="selectedUser.disabled">
              <label for="inputDisabled" style="font-weight: normal">Disabled</label>
            </div>
          </div>

          <small style="color: red;">* Required fields</small>

          <div class="alert alert-danger" role="alert" v-if="saveError">
              <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
              <span class="sr-only">Error:</span>
              {{ saveError }}
          </div>
          
          <div class="alert alert-info" role="alert" v-if="savedConfirmation">
            <span class="glyphicon glyphicon-info-sign" aria-hidden="true"></span>
            <span class="sr-only">Info:</span>
            The user was successfully saved. The following security groups were assigned.
            <ul>
              <li style="font-weight: bold" v-for="g in groups">{{g}}</li>
            </ul>
          </div>
         
        </div>

      </div>
      
      <div class="panel-footer">
        <div class="col-md-offset-8">
          <button type="submit" class="btn btn-primary custom-button" title="Save user">Save</button>
          <router-link class="btn btn-default custom-button pull-right" to="/vue/manage/users" title="Cancel">Cancel</router-link>
        </div>
      </div>

    </form>
  </div>

</template>

<script setup>

    import { computed, ref } from 'vue'
    import { useRoute } from 'vue-router'
    import { manageUserStore } from '@/stores/managedusers.store';
    import { storeToRefs } from "pinia";
    import { useLoading } from "vue-loading-overlay";


    const route = useRoute()
    const saveError = ref('');

    const isNewUser = computed(() => {
        return !(route.params.id > 0);
    })

    const groupsString = computed(() => {
        return store.groups.toString();
    })

    const store = manageUserStore();
    const { selectedUser, groups } = storeToRefs(store)
    const savedConfirmation = ref(false);
    const $loading = useLoading({ active: true });

    async function updateUser() {
        savedConfirmation.value = false;
        const l = $loading.show();

        try {
            savedConfirmation.value = await store.updateUser();
        }
        catch (e) {
            savedConfirmation.value = false;
            saveError.value = e;
        }
        l.hide();
    }

    const loader = $loading.show();

    store.gethUserById(route.params.id)
        .then(loader.hide);

</script>


<style scoped>
h2 {
  display: inline-block;
  margin: 0;
}

label {
  margin-right: 10px;
  margin-left: 10px;
  /*font-weight: normal;*/
}

.custom-button{
  width: 45%;
}


.required:after {
  content: "*";
  padding-left: 2px;
  font-weight: bold;
  color: red;
}

</style>